import { render, staticRenderFns } from "./ServersScreen.vue?vue&type=template&id=c70a931a&"
import script from "./ServersScreen.vue?vue&type=script&lang=js&"
export * from "./ServersScreen.vue?vue&type=script&lang=js&"
import style0 from "./ServersScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports